
import React from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { SortingSelect } from "@/components/nursing-homes/county/SortingSelect";
import { SmartFilters } from "@/components/nursing-homes/county/SmartFilters";
import type { NursingHomeFilters } from "@/hooks/use-county-page-data";

interface SearchSectionProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  sortBy: string;
  setSortBy: (sort: string) => void;
  selectedCounty: string | null;
  setSelectedCounty: (county: string | null) => void;
  counties: { county: string; county_slug: string }[];
  countiesLoading: boolean;
  filters?: NursingHomeFilters;
  setFilters?: (filters: NursingHomeFilters) => void;
  activeFilterCount?: number;
}

export function SearchSection({
  searchQuery,
  setSearchQuery,
  sortBy,
  setSortBy,
  selectedCounty,
  setSelectedCounty,
  counties,
  countiesLoading,
  filters,
  setFilters,
  activeFilterCount = 0,
}: SearchSectionProps) {
  const handleResetCounty = () => {
    setSelectedCounty(null);
  };

  return (
    <div className="mb-8 bg-white rounded-lg border border-gray-100 p-4 sm:p-6 shadow-sm">
      <h2 className="text-2xl font-semibold mb-6 text-center sm:text-left">Search & Filter</h2>
      
      <div className="flex flex-col gap-4 w-full">
        <div className="relative w-full">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-grandpal-gray" size={18} />
          <Input
            type="text"
            placeholder="Search by nursing home name..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-9 py-2 h-11 border-grandpal-beige focus-visible:ring-grandpal-green w-full"
          />
        </div>
        
        <Button 
          variant="outline" 
          onClick={handleResetCounty}
          className="bg-grandpal-green-light hover:bg-grandpal-green hover:text-white text-gray-800 border-0 h-11 w-full"
        >
          All Counties
        </Button>
      </div>

      {/* Smart Filters */}
      {filters && setFilters && (
        <SmartFilters
          filters={filters}
          setFilters={setFilters}
          activeFilterCount={activeFilterCount}
        />
      )}
      
      <div className="mt-5 flex flex-col sm:flex-row items-center justify-center sm:justify-end gap-3">
        <span className="text-sm text-grandpal-gray">Sort by:</span>
        <SortingSelect sortBy={sortBy} setSortBy={setSortBy} />
      </div>
    </div>
  );
}
